export default {
    //智能客服-会话列表
    GET_TALK_LIST: '/api/admin/aisbot/talk/list',
    //智能客服-会话消息列表
    GET_AISBOT_MESSAGE_LIST: '/api/admin/aisbot/message/list',
    //智能客服-发送会话消息
    SEND_AISBOT_MESSAGE: '/api/admin/aisbot/message/send',
}
  